// src/auth/SilentCallback.js
import React, { useEffect } from "react";
import userManager from "./oidcConfig";

const SilentCallback = () => {
  useEffect(() => {
    userManager
      .signinSilentCallback()
      .then(() => {
        console.log("Silent renewal completed successfully");
      })
      .catch((error) => {
        console.error("Silent renewal failed:", error);
      });
  }, []);

  return <div>Renewing token...</div>;
};

export default SilentCallback;
